module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-up-f1f6fcf424d6bb0b811667abb6b05680.svg";